import React from "react";
import Layout from "../../Components/Global/Layout";
const ShippingPage = () => {
    return (
        <Layout>
            
        </Layout>
    )
}
export default ShippingPage;